import { createContext, useContext } from 'react';

export const DefaultFavoriteSubAccountsConfigState = {
  favoriteSubAccounts: [] as string[],
};

export const DefaultFavoriteSubAccountsMethods = {
  setFavoriteSubAccounts: (favoriteSubAccounts: string[]) => {},
};

export const DefaultFavoriteSubAccountsContext = {
  ...DefaultFavoriteSubAccountsConfigState,
  ...DefaultFavoriteSubAccountsMethods,
};

export type FavoriteSubAccountsConfig = typeof DefaultFavoriteSubAccountsConfigState;
export type FavoriteSubAccountsContextProps = typeof DefaultFavoriteSubAccountsContext;

export const DefaultFavoritesSubAccountsConfig: FavoriteSubAccountsContextProps = {
  favoriteSubAccounts: [],
  setFavoriteSubAccounts: () => {},
};

export const FavoriteSubAccountsContext = createContext<FavoriteSubAccountsContextProps>(
  DefaultFavoriteSubAccountsContext
);
FavoriteSubAccountsContext.displayName = 'FavoriteSubAccountsContext';

export function useFavoriteSubAccounts() {
  const context = useContext(FavoriteSubAccountsContext);
  if (context === undefined) {
    throw new Error('Missing FavoriteSubAccountsContext.Provider further up in the tree. Did you forget to add it?');
  }
  return context;
}
